<template>
  <div id="list-view-app" class="vue-list-view">

    <div class="grid-x grid-padding-x toolbar">
      <div class="cell small-12 medium-4">
        <text-filter @filter="applyFilter"></text-filter>
      </div>
    </div>
    <div v-if="columns" class="grid-x grid-padding-x">
      <div class="cell small-12">
        <table class="table">
          <thead>
            <tr>
              <column-header
                v-for="(column, index) in columns"
                :column="column"
                :active="params.sorting.field == column.id"
                :key="index"
                @sort="sortRows">
              </column-header>
            </tr>
          </thead>
          <tbody :class="{ loading: (result && $store.getters.busy) }">
            <template v-if="rows">
              <data-row
                v-for="(row, index) in rows" 
                :key="index"
                :row="row">
              </data-row>
            </template>
            <tr v-else-if="$store.getters.busy">
              <td :colspan="columns.length"><strong>Loading records...</strong></td>
            </tr>
            <tr v-else>
              <td :colspan="columns.length"><strong>No records available.</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="grid-x grid-padding-x">
      <div class="cell small-12">
        <pagination 
          v-if="options.paging == 1 && pageCount > 1"
          :page-count="pageCount"
          :curr-page="params.paging.page"
          :items-per-page="options.items_per_page"
          @to-page="toPage">
        </pagination>
      </div>
    </div>

    <div v-if="$store.getters.error" class="callout alert">
      {{ $store.getters.error }}
    </div>

  </div>
</template>

<script>
import ColumnHeader from '@/ColumnHeader.vue'
import DataRow from '@/DataRow.vue'
import Pagination from '@/Pagination.vue'
import TextFilter from '@/TextFilter.vue'
const VueScrollTo = require('vue-scrollto')

export default {
  name: 'App',
  components: {
    ColumnHeader, DataRow, Pagination, TextFilter
  },
  props: ['appid'],
  methods: {
    init () {
      try {
        // Set options from config data
        let config = document.getElementById('app-config-' + this.appid)
        this.$store.commit('setup', JSON.parse(config.innerHTML))
        this.reload()
      } catch (e) {
        this.$store.commit(
          'error', 
          'An error occurred, this content is currently unavailable.'
        )
      }
    },
    applyFilter (data) {
      this.$store.commit('filter', data)
      this.$store.dispatch('getData', true) // reset arg (bool) sets page to 1
    },
    reload () {
      this.$store.dispatch('getData')
    },
    sortRows (field_id) {
      this.$store.commit('sort', field_id)
      this.$store.dispatch('getData', true)
    },
    toPage (page) {
      this.$store.commit('page', page)
      this.$store.dispatch('getData')
      const self = this
      this.$nextTick(() => {
        VueScrollTo.scrollTo(self.$root.$el, 100, {offset: -20})
      })
    }
  },
  computed: {
    columns () {
      return this.$store.getters.columns
    },
    options () {
      return this.$store.getters.options
    },
    pageCount () {
      if (this.result) {
        const num_rows = this.result.total
        return Math.ceil(num_rows / this.params.paging.items_per_page)
      } else {
        return 0
      }
    },
    params () {
      return this.$store.getters.params
    },
    ready () {
      return this.$store.getters.ready
    },
    result () {
      return this.$store.getters.result
    },
    rows () {
      if (this.result && this.result.rows.length) {
        return this.result.rows
      }
      return false
    }
  },
  mounted () {
    this.init()
  }
}
</script>